import React from "react";
import Filters from "../../../pages/Catalog/Filters/Filters";

interface ModalFilterProps {
  isActive: boolean;
  setIsActive: (value: boolean) => void;
}

const ModalFilter: React.FC<ModalFilterProps> = ({ isActive, setIsActive }) => {
  return (
    <>
      <Filters />
    </>
  );
};

export default ModalFilter;
